import { DownloadBackgroundZip } from 'api/documents.types';
import { DownloadFilesContext } from 'contexts';
import { useContext } from 'react';
import { downloadFile } from 'utils';

interface DataFileType {
  file: Blob | DownloadBackgroundZip;
  name?: string;
}

export const useDownloadFiles = () => {
  const { handleAddKeyToSessionStorage } = useContext(DownloadFilesContext);

  const handleDownloadFiles = (data: DataFileType, disableSessionStorage = false) => {
    if (data.file instanceof Blob) {
      downloadFile(data.file, data.name);
      return;
    }

    data.file && !disableSessionStorage && handleAddKeyToSessionStorage(data.file);
  };

  return { handleDownloadFiles };
};
